import { useTranslation } from 'react-i18next';
import Button from '@/components/Button';
import warningIcon from '@/assets/warning_red.svg';

const PenaltyNotice = ({ variant = 'outstanding', onAction, className }) => {
  const { t } = useTranslation();

  const isBannedVariant = variant === 'banned';

  const copy = isBannedVariant
    ? {
        message: t('penalty.banner.banned.message'),
      }
    : {
        message: t('penalty.banner.outstanding.message'),
        action: t('penalty.banner.outstanding.action'),
      };

  return (
    <div
      className={`w-full px-3 py-3 bg-[#ffedea] border border-[#ffe5df] rounded-md flex items-center gap-3 ${className || ''}`}
    >
      <div className="flex items-center gap-2 flex-1">
        <img src={warningIcon} alt="warning" className="w-4 h-4" />
        <span className="text-sm text-[#ff2b00]">
          {copy.message}
        </span>
      </div>
      {!isBannedVariant && (
        <Button
          variant="danger"
          size="s"
          onClick={onAction}
        >
          {copy.action}
        </Button>
      )}
    </div>
  );
};

export default PenaltyNotice;
